import { ColumnTypeEnum, OperationModel, OperatorEnum } from '@y42/json-schema';

export enum NumericMainPeriodMode {
  Auto = 'auto',
  Custom = 'custom',
}
export enum NumericComparisonPeriodMode {
  None = 'none',
  PreviousPeriod = 'previous_period',
  PreviousYear = 'previous_year',
  Custom = 'custom',
}

export type NumericOperationModel = OperationModel & {
  type: ColumnTypeEnum.Date;
  operator: OperatorEnum.Between;
};

type MainPeriodConfig =
  | { mode: NumericMainPeriodMode.Auto; operation?: undefined }
  | { mode: NumericMainPeriodMode.Custom; operation: NumericOperationModel };

type ComparisonPeriodConfig =
  | { mode: NumericComparisonPeriodMode.None; operation?: undefined }
  | { mode: NumericComparisonPeriodMode.PreviousPeriod; operation?: undefined }
  | { mode: NumericComparisonPeriodMode.PreviousYear; operation?: undefined }
  | { mode: NumericComparisonPeriodMode.Custom; operation: NumericOperationModel };

export interface NumericDimensionConfig {
  mainPeriod: MainPeriodConfig;
  comparisonPeriod: ComparisonPeriodConfig;
}

export const defaultNumericDimensionConfig: NumericDimensionConfig = {
  mainPeriod: { mode: NumericMainPeriodMode.Auto },
  comparisonPeriod: { mode: NumericComparisonPeriodMode.None },
};
